export function appendSessionFilterToParams(
  params: URLSearchParams,
  key: string,
  value: string | string[] | undefined,
): void {
  if (value === undefined || value === null || value === '') return;
  if (Array.isArray(value)) {
    value.forEach(v => {
      if (v) params.append(key, String(v));
    });
    return;
  }
  params.set(key, String(value));
}
